import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.5rem'
  },

  button: {
    float: 'right',
    marginTop: '1rem',
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
